export const FEED = 'feed';
export const FEED_LIST = 'feed-list';
export const MEMBERS_BADGES = 'members-badges';
export const REACTIONS = 'reactions';
